import React from "react";
import { Link } from "react-router-dom"; // Import Link from React Router
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/global.css";
import "../css/index.css";

const Navbar = () => {
    return (
        <>
            {/* Top Section - Visible Only on Large Screens */}
            <section id="top" className="bg_light pt-3 pb-3 d-none d-md-block">
                <div className="container-xl">
                    <div className="row align-items-center">
                        <div className="col-md-3">
                            <h2 className="mb-0">
                                <Link className="text-black text-decoration-none" to="/">Irfan Electricals</Link>
                            </h2>
                        </div>
                        <div className="col-md-9 text-end">
                            <ul className="list-inline mb-0">
                                <li className="list-inline-item mx-3">
                                    <a href="#"><i className="fa fa-envelope col_blue me-1"></i> info@irfanelectricals.com</a>
                                </li>
                                <li className="list-inline-item mx-3">
                                    <a href="#"><i className="fa fa-phone col_blue me-1"></i> +91 9898100371</a>
                                </li>
                                {/* Icons for Large Screens */}
                                <li className="list-inline-item mx-3 d-none d-md-inline">
                                    <Link to="/profile"><i className="fa fa-user col_blue fs-4"></i></Link>
                                </li>
                                <li className="list-inline-item mx-3 d-none d-md-inline">
                                    <Link to="/cart"><i className="fa fa-shopping-cart col_blue fs-4"></i></Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            {/* Navigation Bar */}
            <section id="header">
                <nav className="navbar navbar-expand-md navbar-light bg_blue" id="navbar_sticky">
                    <div className="container-xl d-flex align-items-center justify-content-between">
                        
                        {/* Brand Name (Left) */}
                        <Link className="navbar-brand fw-bold text-white"
                            to="/"
                            style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontSize: "1rem" }}>
                            Irfan Electricals
                        </Link>

                        {/* Navigation Menu (Centered) */}
                        <div className="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
                            <ul className="navbar-nav mb-0">
                                <li className="nav-item"><Link className="nav-link text-white" to="/">Home</Link></li>
                                <li className="nav-item"><Link className="nav-link text-white" to="/about">About</Link></li>
                                <li className="nav-item"><Link className="nav-link text-white" to="/shop">Shop</Link></li>
                                <li className="nav-item"><Link className="nav-link text-white" to="/blog">Blog</Link></li>
                                <li className="nav-item"><Link className="nav-link text-white" to="/certification">Certifications</Link></li>
                                <li className="nav-item"><Link className="nav-link text-white" to="/contact">Contact</Link></li>
                            </ul>
                        </div>

                        {/* Icons - Visible Only on Small Screens */}
                        <div className="d-flex align-items-center d-md-none">
                            <Link className="nav-link text-white mx-2" to="/profile">
                                <i className="fa fa-user fs-5"></i>
                            </Link>
                            <Link className="nav-link text-white mx-2" to="/cart">
                                <i className="fa fa-shopping-cart fs-5"></i>
                            </Link>

                            {/* Toggler Button (Mobile Only) */}
                            <button
                                className="navbar-toggler ms-2"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target="#navbarSupportedContent"
                                aria-controls="navbarSupportedContent"
                                aria-expanded="false"
                                aria-label="Toggle navigation"
                            >
                                <span className="navbar-toggler-icon"></span>
                            </button>
                        </div>
                    </div>
                </nav>

                {/* Search Bar - Visible Only on Small Screens */}
                <div className="container-xl d-md-none mt-2">
                    <div className="d-flex justify-content-between align-items-center">
                        {/* Search Bar */}
                        <div className="input-group" style={{ maxWidth: "180px", flex: "1" }}>
                            <input 
                                className="form-control form-control-sm border-0" 
                                type="text" 
                                placeholder="Search..." 
                            />
                            <button className="btn btn-outline-light p-1" type="button">
                                <i className="fa fa-search"></i>
                            </button>
                        </div>

                        {/* Toggler Button */}
                        <button
                            className="navbar-toggler"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation"
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Navbar;
